A possible response to a `DraftApplicationQuestion`.
